export default __webpack_public_path__ + "static/media/technicalIcon.1a1a5e9c.svg";